import { initializeIcons } from "@fluentui/react";
import { useContainerStyles } from "../@styles/container.styles";
import Authorization from "../components/auth/authorization";
import DatabaseBackup from "../components/database-backup/database-backup";
import { UserPermission } from "../constants/permissions.constants";

const DatabaseBackupRestorePage = () => {
  const contClasses = useContainerStyles();
  initializeIcons();
  return (
    <Authorization>
      <section
        key={UserPermission.P_DATABASE_BACKUP}
        className={contClasses.sectionContainer}
      >
        <div className={"dashboard-tile " + contClasses.boxContainer}>
          <div className={contClasses.root}>
            <div style={{ marginTop: "3rem" }}>
              <div style={{ paddingLeft: "1rem", width: "90%" }}></div>
              <DatabaseBackup />
            </div>
          </div>
        </div>
      </section>
    </Authorization>
  );
};

export default DatabaseBackupRestorePage;
